import * as Constants from "../constants";

export const getEntrypointsLives = () => ({
  type: Constants.GET_ENTRYPOINTS_LIVES,
});

export const getEntrypointsLivesSuccess = (data) => ({
  type: Constants.GET_ENTRYPOINTS_LIVES_SUCCESS,
  payload: data,
});

export const getEntrypointsLivesError = (error) => ({
  type: Constants.GET_ENTRYPOINTS_LIVES_ERROR,
  error,
});

export const getFeaturedLives = () => ({
  type: Constants.GET_FEATURED_LIVES,
});

export const getFeaturedLivesSuccess = (data) => ({
  type: Constants.GET_FEATURED_LIVES_SUCCESS,
  payload: data,
});

export const getFeaturedLivesError = (error) => ({
  type: Constants.GET_FEATURED_LIVES_ERROR,
  error,
});

export const getNextLives = () => ({
  type: Constants.GET_NEXT_LIVES,
});

export const getNextLivesSuccess = (data) => ({
  type: Constants.GET_NEXT_LIVES_SUCCESS,
  payload: data,
});

export const getNextLivesError = (error) => ({
  type: Constants.GET_NEXT_LIVES_ERROR,
  error,
});
